import jQuery from "jquery";
import '../plugins/responsiveHelper';
import 'slick-carousel';

// slickCarousel init
export default function initSlickCarousel() {
	ResponsiveHelper.addRange({
		'..1023': {
		  on: function () {
				jQuery('.js-slider').slick({
					slidesToScroll: 1,
					rows: 0,
					arrows: false,
					dots: true,
					dotsClass: 'slick-dots',
					infinite: true,
					// adaptiveHeight: true,
					pauseOnHover: false,
					responsive: [
						{
							breakpoint: 2400,
							settings: "unslick"
						},
						{
							breakpoint: 1023,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							}
						},
						{
							breakpoint: 767,
							settings: {
								adaptiveHeight: true,
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});


		  },
		  off: function () {
			jQuery('.js-slider').slick('unslick');
		  }
		}
	});
	jQuery('.review-slider').each(function() {
		const reviewSlider = jQuery(this);
		
		reviewSlider.on('init', function(event, slick){
			const boxesClass = '.box .top-block';
			let maxHeight = 0;
			let timer;

			function resizeHandler() {
				clearTimeout(timer)
				timer = setTimeout(function(){
					maxHeight = 0;
					slick.$slider.find(boxesClass).each(function(){
						const top = jQuery(this);
						top.css({
							height: 'auto'
						});
						maxHeight = Math.max(maxHeight, top.innerHeight());
					});
					console.log(maxHeight)
					slick.$slider.find(boxesClass).each(function(){
						const top = jQuery(this);
						top.css({
							height: maxHeight
						});
					});

				}, 200)
			}
			resizeHandler();
			window.addEventListener('resize', resizeHandler);
		});
		reviewSlider.slick({
			slidesToScroll: 1,
			rows: 0,
			slidesToShow: 2,
			infinite: false,
			prevArrow: '<button class="slick-prev"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 3.19772L1 3.19772M1 3.19772L8.73441 0.913147M1 3.19772L7.76267 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
			nextArrow: '<button class="slick-next"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.19772L19 3.19772M19 3.19772L11.2656 0.913147M19 3.19772L12.2373 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
			responsive: [{
				breakpoint: 1023,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1
				}
			}]
		});
	})

	jQuery('.images-slider').each(function(){
		const slider = jQuery(this);
		const controlsBox = jQuery('<div class="slider-pagination">');
		slider.on('init', function(event, swiper) {


			controlsBox.insertBefore(swiper.$dots);
			controlsBox.append(swiper.$prevArrow).append(swiper.$dots).append(swiper.$nextArrow)

		});

		slider.slick({
			slidesToScroll: 1,	
			rows: 0,
			slidesToShow: 1,
			infinite: false,
			dots: true,
			dotsClass: 'slick-dots',
			prevArrow: '<button class="slick-prev"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 3.19772L1 3.19772M1 3.19772L8.73441 0.913147M1 3.19772L7.76267 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
			nextArrow: '<button class="slick-next"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.19772L19 3.19772M19 3.19772L11.2656 0.913147M19 3.19772L12.2373 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
		});

		
	});
}